import React, { useState } from "react";
import PalpitesShowBanner from "@/components/palpites-show/PalpitesShowBanner";
import SlideRenderer, { TOTAL_STEPS } from "@/components/palpites-show/SlideRenderer";
import { gerarPalpites, PalpitesData } from "@/components/palpites-show/palpitesGenerator";
import { Button } from "@/components/ui/button";
import { ChevronLeft, RotateCcw, Sparkles, Play, Image as ImageIcon } from "lucide-react";
import GerarVideoModal from "@/components/palpites-show/GerarVideoModal";
import GerarImagemModal from "@/components/palpites-show/GerarImagemModal";


const PalpitesShowPage: React.FC = () => {
  const [data, setData] = useState<PalpitesData>(() => gerarPalpites());
  const [step, setStep] = useState(0);
  const [started, setStarted] = useState(false);
  const [videoOpen, setVideoOpen] = useState(false);
  const [imagemOpen, setImagemOpen] = useState(false);


  const next = () => setStep((s) => Math.min(TOTAL_STEPS - 1, s + 1));
  const prev = () => setStep((s) => Math.max(0, s - 1));
  const reset = () => {
    setStep(0);
    setStarted(false);
  };
  const regen = () => {
    setData(gerarPalpites());
    setStep(0);
    setStarted(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-neutral-950 to-black py-6 px-4">
      <div className="max-w-5xl mx-auto space-y-6">
        <PalpitesShowBanner data={data.data} />

        {!started ? (
          <div className="bg-neutral-900 border-4 border-yellow-500/60 rounded-3xl p-12 text-center space-y-6 min-h-[520px] flex flex-col items-center justify-center">
            <Sparkles className="w-20 h-20 text-yellow-400" />
            <h1 className="text-4xl md:text-6xl font-black text-white uppercase">
              Palpites Show
            </h1>
            <p className="text-xl text-yellow-300 max-w-2xl">
              Modo apresentação para gravação de vídeos do canal. Clique em <b>Gerar Palpite</b> e revele
              cada slide em fonte gigante, mantendo o banner IA Palpite Guru sempre no topo.
            </p>
            <Button
              onClick={() => setStarted(true)}
              size="lg"
              className="bg-yellow-500 hover:bg-yellow-600 text-black text-2xl font-black px-10 py-8 rounded-2xl shadow-2xl"
            >
              <Play className="w-8 h-8 mr-2" /> Iniciar Apresentação
            </Button>
          </div>
        ) : (
          <SlideRenderer step={step} data={data} />
        )}

        {started && (
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 bg-neutral-900 border-2 border-yellow-500/40 rounded-2xl p-4">
            <div className="text-yellow-300 font-bold text-lg">
              Passo {step + 1} / {TOTAL_STEPS}
            </div>
            <div className="flex flex-wrap items-center gap-2 justify-center">
              <Button variant="outline" onClick={prev} disabled={step === 0}>
                <ChevronLeft className="w-4 h-4 mr-1" /> Voltar
              </Button>
              <Button variant="outline" onClick={reset}>
                <RotateCcw className="w-4 h-4 mr-1" /> Reiniciar
              </Button>
              <Button
                variant="outline"
                onClick={regen}
                className="border-yellow-500 text-yellow-500 hover:bg-yellow-500/10"
              >
                <Sparkles className="w-4 h-4 mr-1" /> Nova Sequência
              </Button>
              <Button
                onClick={next}
                disabled={step === TOTAL_STEPS - 1}
                className="bg-yellow-500 hover:bg-yellow-600 text-black font-black text-lg px-6"
              >
                Gerar Próximo Palpite <Sparkles className="w-4 h-4 ml-2" />
              </Button>
            </div>
          </div>
        )}

        {started && (
          <div className="flex justify-center">
            <Button
              size="lg"
              onClick={() => setImagemOpen(true)}
              className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-black text-lg px-8 py-6 rounded-2xl shadow-xl"
            >
              <ImageIcon className="w-5 h-5 mr-2" />
              🖼️ Gerar Imagem 16:9 (Capa YouTube)
            </Button>
          </div>
        )}

        <GerarImagemModal open={imagemOpen} onOpenChange={setImagemOpen} data={data} />
        <GerarVideoModal open={videoOpen} onOpenChange={setVideoOpen} data={data} />

      </div>
    </div>
  );
};

export default PalpitesShowPage;
